import { useCallback } from "react";

import { type RecoilState, useRecoilState } from "recoil";

import { type Visibility } from "../../gql-generated/types";

export const useVisibility = (
    visibilityState: RecoilState<Visibility>,
): { visibility: Visibility; setVisibility: (value: Visibility) => void } => {
    const [visibility, setVisibility] = useRecoilState(visibilityState);

    const setVisibilityValue = useCallback(
        (value: Visibility) => {
            setVisibility(value);
        },
        [setVisibility],
    );

    return { visibility, setVisibility: setVisibilityValue };
};
